import React from "react";
export const Footercomponent = () => {
  return (
    <>
      <div className="wa__ticketapp__footer">
        <ul className="wa__ticketapp__footer__nav">
          <li className="wa__ticketapp__footer__nav__listitem">
            <a
              className="wa__ticketapp__footer__nav__listitem__link"
              href="https://www.unitymedia.de/privatkunden/impressum/"
            >
              Impressum
            </a>
          </li>
          <li className="wa__ticketapp__footer__nav__listitem">
            <a
              className="wa__ticketapp__footer__nav__listitem__link"
              href="https://www.unitymedia.de/privatkunden/agb/"
            >
              AGB & Preise
            </a>
          </li>
          <li className="wa__ticketapp__footer__nav__listitem">
            <a
              className="wa__ticketapp__footer__nav__listitem__link"
              href="https://www.vodafone.de/unternehmen/soziale-verantwortung/datenschutz-privatsphaere.html?uc=RDR"
            >
              Datenschutz
            </a>
          </li>
          <li className="wa__ticketapp__footer__nav__listitem">
            <a
              className="wa__ticketapp__footer__nav__listitem__link"
              href="https://www.unitymedia.de/privatkunden/hilfe_service/wissenswertes/pib/"
            >
              Produktinformationsblätter
            </a>
          </li>
          <li className="wa__ticketapp__footer__nav__listitem">
            <a
              className="wa__ticketapp__footer__nav__listitem__link"
              href="https://www.vodafone.de/filialsuche.html?uc=GEN&sales_id=43904&c_id=umo_ref:nsitelink&j_id=ConConPer723F"
            >
              Shopsuche
            </a>
          </li>
          <li className="wa__ticketapp__footer__nav__listitem">
            <a
              className="wa__ticketapp__footer__nav__listitem__link"
              href="https://www.vodafone.de/sitemap.html"
            >
              Sitemap
            </a>
          </li>
          <li className="wa__ticketapp__footer__nav__listitem">
            <a
              className="wa__ticketapp__footer__nav__listitem__link"
              href="https://www.unitymedia.de/privatkunden/kontakt/"
            >
              Kontakt
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};


